"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonToggleItem = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("../");
exports.ButtonToggleItem = react_1.default.forwardRef(function (_a, ref) {
    var color = _a.color, disabled = _a.disabled, hidden = _a.hidden, icon = _a.icon, iconName = _a.iconName, name = _a.name, onClick = _a.onClick, selected = _a.selected, size = _a.size, text = _a.text, value = _a.value;
    var realColor = 'default';
    if (selected)
        realColor = color;
    var ButtonToggleItemClasses = classnames_1.default('ButtonToggle__Item', {
        'ButtonToggle__Item--hidden': hidden,
        'ButtonToggle__Item--selected': selected,
        'ButtonToggle__Item--not-selected': !selected,
        'ButtonToggle__Item--disabled': disabled,
    });
    return (react_1.default.createElement("div", { className: ButtonToggleItemClasses, ref: ref },
        react_1.default.createElement("input", { name: name, type: "radio", defaultChecked: selected, className: "ButtonToggle__radio" }),
        react_1.default.createElement(__1.Button, { color: realColor, disabled: disabled, fill: "solid", full: true, icon: icon, iconName: iconName, onClick: onClick.bind(null, value), size: size }, text)));
});
//# sourceMappingURL=ButtonToggleItem.js.map